module.exports = __webpack_public_path__ + "static/media/qijia.51d26603.png";